import { cleanEntity } from 'shared/lib/util/entity-utils';
import { cmsHttp } from 'shared/api/mfe-axios';
import { buildSpringPageParams } from 'shared/api/list-query-params';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
import { defaultValue } from '@entities/card-product/model';
export const ACTION_TYPES = {
    FETCH_CARD_PRODUCTS_LIST: 'cardProduct/FETCH_CARD_PRODUCTS_LIST',
    FETCH_CARD_PRODUCT: 'cardProduct/FETCH_CARD_PRODUCT',
    CREATE_CARD_PRODUCT: 'cardProduct/CREATE_CARD_PRODUCT',
    UPDATE_CARD_PRODUCT: 'cardProduct/UPDATE_CARD_PRODUCT',
    DELETE_CARD_PRODUCT: 'cardProduct/DELETE_CARD_PRODUCT',
    RESET: 'cardProduct/RESET',
    RESET_ENTITY: 'cardProduct/RESET_ENTITY',
};
const listApiUrl = 'api/card-products';
const apiUrl = 'api/card-products';
const initialState = {
    loading: false,
    loadingEntity: false,
    errorMessage: null,
    entities: [],
    entity: defaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_PRODUCTS_LIST):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.FETCH_CARD_PRODUCT):
            return {
                ...state,
                errorMessage: null,
                loadingEntity: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_PRODUCT):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_PRODUCT):
        case REQUEST(ACTION_TYPES.DELETE_CARD_PRODUCT):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_PRODUCTS_LIST):
        case FAILURE(ACTION_TYPES.CREATE_CARD_PRODUCT):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_PRODUCT):
        case FAILURE(ACTION_TYPES.DELETE_CARD_PRODUCT):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_PRODUCT):
            return {
                ...state,
                loadingEntity: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_PRODUCTS_LIST): {
            const body = action.payload.data;
            const list = Array.isArray(body) ? body : body?.content ?? [];
            const countHeader = action.payload.headers?.['x-total-count'];
            const total = countHeader != null && countHeader !== '' ? parseInt(countHeader, 10) : list.length;
            return {
                ...state,
                loading: false,
                entities: list.map((row) => normalizeCardProduct(row)),
                totalItems: Number.isNaN(total) ? list.length : total,
            };
        }
        case SUCCESS(ACTION_TYPES.FETCH_CARD_PRODUCT):
            return {
                ...state,
                loadingEntity: false,
                entity: normalizeCardProduct(action.payload.data),
            };
        case SUCCESS(ACTION_TYPES.CREATE_CARD_PRODUCT):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_PRODUCT):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: normalizeCardProduct(action.payload.data),
                loading: false,
            };
        case SUCCESS(ACTION_TYPES.DELETE_CARD_PRODUCT):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                entity: defaultValue,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        case ACTION_TYPES.RESET_ENTITY:
            return {
                ...state,
                entity: defaultValue,
                loadingEntity: false,
            };
        default:
            return state;
    }
};
export const getEntities = (params) => ({
    type: ACTION_TYPES.FETCH_CARD_PRODUCTS_LIST,
    payload: cmsHttp().get(listApiUrl, params === undefined ? undefined : { params: buildSpringPageParams(params) }),
});
export const getEntity = (id) => ({
    type: ACTION_TYPES.FETCH_CARD_PRODUCT,
    payload: cmsHttp().get(`${apiUrl}/${id}`),
});
export const resetEntity = () => ({ type: ACTION_TYPES.RESET_ENTITY });
const normalizeCardProduct = (raw) => {
    const { cardIssuanceFee, cardReplacementFee, issuanceFeeAmount, replacementFeeAmount, ...rest } = raw;
    return {
        ...rest,
        issuanceFeeAmount: issuanceFeeAmount ?? cardIssuanceFee ?? null,
        replacementFeeAmount: replacementFeeAmount ?? cardReplacementFee ?? null,
    };
};
const toApiBody = (entity, options) => {
    const limits = entity.cardLimits ?? [];
    const restrictions = entity.cardRestrictions ?? [];
    const { id, cardIssuanceFee: _legacyIssuance, cardReplacementFee: _legacyReplacement, ...rest } = entity;
    const body = {
        ...rest,
        cardLimits: Array.isArray(limits) ? limits : [],
        cardRestrictions: Array.isArray(restrictions) ? restrictions : [],
    };
    if (options?.includeId && id != null) {
        return { ...body, id };
    }
    return body;
};
export const createEntity = (entity) => async (dispatch) => {
    const body = toApiBody(entity);
    return dispatch({
        type: ACTION_TYPES.CREATE_CARD_PRODUCT,
        payload: cmsHttp().post(apiUrl, body),
    });
};
export const updateEntity = (entity) => async (dispatch) => {
    if (entity.id == null) {
        return undefined;
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_PRODUCT,
        payload: cmsHttp().patch(`${apiUrl}/${entity.id}`, cleanEntity(toApiBody(entity, { includeId: true }))),
    });
};
export const deleteEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.DELETE_CARD_PRODUCT,
    payload: cmsHttp().delete(`${apiUrl}/${id}`),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
